import { render, staticRenderFns } from "./voiceCompose.vue?vue&type=template&id=75d0adc4&scoped=true&"
import script from "./voiceCompose.vue?vue&type=script&lang=js&"
export * from "./voiceCompose.vue?vue&type=script&lang=js&"
import style0 from "./voiceCompose.vue?vue&type=style&index=0&id=75d0adc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d0adc4",
  null
  
)

component.options.__file = "voiceCompose.vue"
export default component.exports